import React from 'react';
import { limpiarTexto } from '../utils/validacion';

// Campo de formulario reutilizable con etiqueta y mensaje de error.
// `maxLargo` evita que un texto pegado por error rompa listas y etiquetas.
export default function CampoTexto({ label, tipo = 'text', valor, error, deshabilitado, onChange, maxLargo = 200 }) {
  const escribir = (e) => onChange(limpiarTexto(e.target.value, maxLargo));
  const largo = String(valor ?? '').length;
  const casiLleno = largo >= maxLargo - 10;

  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: '600', color: '#374151' }}>{label}</label>
      <input type={tipo} value={valor ?? ''} disabled={deshabilitado} onChange={escribir} maxLength={maxLargo}
        style={{ width: '100%', padding: '10px', border: error ? '1px solid #EF4444' : '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
      {error && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#EF4444' }}>⚠ {error}</p>}
      {!error && casiLleno && (
        <p style={{ margin: '4px 0 0', fontSize: '11px', color: '#9CA3AF' }}>{largo} de {maxLargo} letras</p>
      )}
    </div>
  );
}
